/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum Preference {
    Neutral = 'Neutral',
    Favour = 'Favour',
    DisFavour = 'DisFavour'
}

export function PreferenceFromJSON(json: any): Preference {
    return PreferenceFromJSONTyped(json, false);
}

export function PreferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): Preference {
    return json as Preference;
}

export function PreferenceToJSON(value?: Preference | null): any {
    return value as any;
}

